import { LiveQuotesSections } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/liveForm/sections.connect';

export type LiveFormContentProps = { tabId: string };
export function LiveFormContent({ tabId }: LiveFormContentProps) {
  return (
    <>
      <LiveQuotesSections.ConnectedProductSummary tabId={tabId} />
      <LiveQuotesSections.ConnectedTradeInformation tabId={tabId} isModification={false} />
      <LiveQuotesSections.ConnectedBookingInformation tabId={tabId} />
    </>
  );
}

LiveFormContent.displayName = 'LiveFormContent';
